import React from 'react';

const Shrimmer = ({ fast }) => {
  return (
    <div className={`shrimmer-wrapper ${fast ? 'fast' : ''}`}>
      <div className="shrimmer"></div>
    </div>
  );
};

export default Shrimmer;
